import React from "react";
import { useTranslation } from "react-i18next";

import SportStatisticsStore from "@state/stores/offer/statistics/SportStatisticsStore";

export default function EventArticle(props: {
	store: SportStatisticsStore;
	shouldShowDetails: boolean;
}) {
	const { t } = useTranslation();

	if (!props.shouldShowDetails) {
		return null;
	}

	if (!props.store.articleInsights) {
		return null;
	}

	return (
		<div className="card card--raised">
			<div className="card__body markdown u-type--sml">
				{props.store.articleInsights?.matchSummary ? (
					<p>
						<strong>
							{props.store.articleInsights.matchSummary}
						</strong>
					</p>
				) : null}

				{props.store.articleInsights?.tipSubtitle ? (
					<h2>{props.store.articleInsights.tipSubtitle}</h2>
				) : null}

				{props.store.articleInsights?.articleTips ? (
					<>
						{props.store.articleInsights.articleTips?.map(
							(tip, index) => (
								<React.Fragment key={index}>
									<h3>
										{t("COMMON.TIP")} {index + 1}:{" "}
										{tip.tipHeader}
									</h3>
									<ul className="u-mar--top--reset">
										{tip.tipBullets.map(
											(bullet, bulletIndex) => (
												<li key={bulletIndex}>
													{bullet}
												</li>
											)
										)}
									</ul>
								</React.Fragment>
							)
						)}
					</>
				) : null}

				{props.store.articleInsights?.teamOneNewsHeader &&
				props.store.articleInsights?.teamOneBullets ? (
					<>
						<h3>{props.store.articleInsights.teamOneNewsHeader}</h3>
						<ul className="u-mar--top--reset">
							{props.store.articleInsights.teamOneBullets.map(
								(teamOneBullet, index) => {
									return <li key={index}>{teamOneBullet}</li>;
								}
							)}
						</ul>
					</>
				) : null}

				{props.store.articleInsights?.teamTwoNewsHeader &&
				props.store.articleInsights?.teamTwoBullets ? (
					<>
						<h3>{props.store.articleInsights.teamTwoNewsHeader}</h3>
						<ul className="u-mar--top--reset">
							{props.store.articleInsights.teamTwoBullets.map(
								(teamTwoBullet, index) => {
									return <li key={index}>{teamTwoBullet}</li>;
								}
							)}
						</ul>
					</>
				) : null}

				{props.store.articleInsights?.predictionSubtitle &&
				props.store.articleInsights?.predictionSummary ? (
					<>
						<h3>
							{props.store.articleInsights.predictionSubtitle}
						</h3>
						<p>{props.store.articleInsights.predictionSummary}</p>
					</>
				) : null}
			</div>
		</div>
	);
}
